import React, { useEffect, useRef, useState } from "react";
import { Edit2, Trash2 } from "lucide-react";
import { toast } from "react-toastify";
import AssessmentForm from "./AssessmentForm";

import {
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import {
  createAssessment,
  deleteAssessment,
  getAssessments,
} from "../../services/AssessmentService";
import UploadService from "../../services/UploadService";
import { HOSTNAME } from "../../common/apiClient";
import axios from "axios";
import { toLowerCaseNonAccentVietnamese } from "../../common/Utils";
import { getExamByIds } from "../../services/ExamService";

const configDate = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
  timeZone: "Asia/Ho_Chi_Minh", // hoặc remove nếu dùng UTC
};

export default function Assessment() {
  // ]);
  const [formData, setFormData] = useState({
    title: "",
    imgUrl: "",
    type: "TSA",
    access: "PUBLIC",
    typeExam: "ĐỀ THI THỬ",
    subject: "",
    isLeaderboard: false,
  });
  const [childExamIDs, setChildExamIDs] = useState([]);
  const [selectedExams, setSelectedExams] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 20;
  const [isEditing, setIsEditing] = useState(null);
  const [isSearch, setIsSearch] = useState(false);
  const [listAssessments, setListAssessments] = useState([]);
  const examsPerPage = 5;
  const indexOfLastExam = currentPage * examsPerPage;
  const [searchQuery, setSearchQuery] = useState("");
  const imageRefDoc = useRef(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [assessmentToDelete, setAssessmentToDelete] = useState(null);

  const handleFetch = async () => {
    try {
      const response = await getAssessments(currentPage, limit, searchQuery);
      setListAssessments(response?.data);
      setTotalPages(response?.totalPages);
      setCurrentPage(response?.currentPage);
    } catch (error) {
      const message = error?.response?.data?.message;
      toast.error(message);
    }
  };

  useEffect(() => {
    handleFetch();
  }, [currentPage]);

  const handleEditAssessment = async (assessment) => {
    setIsEditing(true);
    setFormData({ ...assessment, title: assessment?.title?.text });
    setChildExamIDs(assessment?.childExamIDs);
    try {
      const response = await getExamByIds({ ids: assessment?.childExamIDs });
      if (response && response.data) {
        setSelectedExams(response.data);
      }
    } catch (error) {
      const message = error?.response?.data?.message;
      toast.error(message);
    }
  };

  const handleDeleteClick = (assessment) => {
    setAssessmentToDelete(assessment);
    setDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setAssessmentToDelete(null);
  };

  const handleConfirmDeleteAssessment = async () => {
    if (!assessmentToDelete?._id) return;
    try {
      const res = await deleteAssessment(assessmentToDelete._id);
      toast.success(res?.message);
      setListAssessments(
        listAssessments.filter((a) => a?._id !== assessmentToDelete._id)
      );
      handleCloseDeleteDialog();
    } catch (error) {
      const message = error?.response?.data?.message;
      toast.error(message);
    }
  };

  const handleInsertAssessment = async () => {
    const uniquechildExamIDs = [...new Set(childExamIDs)];
    if (validateForm()) {
      try {
        const res = await createAssessment({
          ...formData,
          title: {
            text: formData.title.toUpperCase(),
            code: toLowerCaseNonAccentVietnamese(formData.title).toUpperCase(),
          },
          childExamIDs: uniquechildExamIDs,
        });
        if (res && res.data) {
          setListAssessments([res.data, ...listAssessments]);
          handleFetch();
          toast.success(res?.message);
          setFormData({
            title: "",
            imgUrl: "",
          });
          setChildExamIDs([]);
          setSelectedExams([]);
        }
      } catch (error) {
        const message = error?.response?.data?.message;
        toast.error(message);
      }
    }
  };

  const handleUpdateAssessment = async () => {
    const uniquechildExamIDs = [...new Set(childExamIDs)];
    if (validateForm()) {
      try {
        const res = await createAssessment({
          ...formData,
          title: {
            text: formData.title.toUpperCase(),
            code: toLowerCaseNonAccentVietnamese(formData.title).toUpperCase(),
          },
          childExamIDs: uniquechildExamIDs,
        });
        if (res && res.data) {
          setListAssessments(
            listAssessments.map((e) => (e._id === res.data?._id ? res.data : e))
          );
          handleFetch();
          toast.success(res?.message);
          setFormData({
            title: "",
            imgUrl: "",
          });
          setChildExamIDs([]);
          setSelectedExams([]);
        }
      } catch (error) {
        const message = error?.response?.data?.message;
        toast.error(message);
      }
    }
  };
  const validateForm = () => {
    if (!formData.title) {
      toast.error("Vui lòng tiêu đề");
      return false;
    }

    if (!childExamIDs.length === 0) {
      toast.error("Vui lòng thêm đề thi");
      return false;
    }

    return true;
  };

  const handleChangeInputAssessment = (event) => {
    let { name, value } = event.target;
    if (name === "role") {
      const role = value === "Admin" ? 1 : 0;
      setFormData({
        ...formData,
        [name]: role,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearch = () => {
    if (searchQuery) {
      setIsSearch(true);
    } else {
      setIsSearch(false);
    }
    setCurrentPage(1); // Reset page on search
    handleFetch(); // Fetch data with query
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (searchQuery) {
        setIsSearch(true);
      } else {
        setIsSearch(false);
      }
      handleSearch(); // Trigger search when Enter is pressed
    }
  };

  const upLoadImageAssessment = async (event) => {
    try {
      const file = event.target?.files[0];
      if (file) {
        // Upload using multer backend
        const response = await UploadService.uploadImage(file);

        if (response && response.data && response.data.imageUrl) {
          const imageUrl = `${HOSTNAME}${response.data.imageUrl}`;
          console.log("🚀 ~ upLoadImageAssessment ~ imageUrl:", imageUrl);
          setFormData({
            ...formData,
            imgUrl: imageUrl,
          });
          toast.success("Tải ảnh lên thành công");
          imageRefDoc.current.value = null;
        }
      }
    } catch (error) {
      console.error("Upload error:", error);
      const errorMessage =
        error?.response?.data?.message || "Tải ảnh lên thất bại";
      toast.error(errorMessage);
    }
  };
  return (
    <div className="p-[30px] overflow-auto">
      <h2 className="text-3xl font-bold mb-6 text-gray-800">Quản Lý Bài Thi</h2>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="delete-assessment-dialog-title"
        aria-describedby="delete-assessment-dialog-description"
      >
        <DialogTitle id="delete-assessment-dialog-title">Xác nhận xóa</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-assessment-dialog-description">
            Bạn có chắc chắn muốn xóa bài thi{" "}
            <strong>{assessmentToDelete?.title?.text}</strong>? Hành động này không thể hoàn tác.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="inherit">
            Hủy
          </Button>
          <Button onClick={handleConfirmDeleteAssessment} color="error" variant="contained" autoFocus>
            Xóa
          </Button>
        </DialogActions>
      </Dialog>

      {/* Assessment Form */}
      <AssessmentForm
        isEditing={isEditing}
        formData={formData}
        handleInsertAssessment={handleInsertAssessment}
        handleChangeInputAssessment={handleChangeInputAssessment}
        handleUpdateAssessment={handleUpdateAssessment}
        upLoadImageAssessment={upLoadImageAssessment}
        imageRefDoc={imageRefDoc}
        childExamIDs={childExamIDs}
        setChildExamIDs={setChildExamIDs}
        selectedExams={selectedExams}
        setSelectedExams={setSelectedExams}
      />
      {/* Search Input */}
      <div className="mb-4 mt-5 flex items-center space-x-2">
        <input
          type="text"
          placeholder="Tìm kiếm bài thi.."
          value={searchQuery}
          onChange={handleSearchChange}
          onKeyPress={handleKeyPress} // Listen for Enter key
          className="w-96 px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring"
        />
        <button
          onClick={handleSearch}
          className="px-4 py-2 bg-blue-600 text-white rounded-md"
        >
          Search
        </button>
      </div>

      {/* Assessment Table */}
      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        <div className="max-h-96 overflow-y-auto">
          {" "}
          {/* Thêm cuộn dọc nếu có quá nhiều hàng */}
          <table className="w-full">
            <thead className="bg-gray-100 border-b">
              <tr>
                <th className="p-3 text-left">No</th>
                <th className="p-3 text-left">Tên</th>
                <th className="p-3 text-left">Kì thi</th>
                <th className="p-3 text-left">Truy cập</th>
                <th className="p-3 text-left">Loại đề thi</th>
                <th className="p-3 text-left">Môn học</th>
                <th className="p-3 text-left">Xem BXH</th>
                <th className="p-3 text-center">Hành động</th>
              </tr>
            </thead>
            <tbody>
              {listAssessments.length > 0 &&
                listAssessments.map((Assessment, index) => (
                  <tr
                    key={Assessment?._id}
                    className="border-b hover:bg-gray-50 transition"
                  >
                    <Tooltip title={Assessment?._id} placement="top">
                      <td className="p-3">
                        {" "}
                        {Assessment?._id?.slice(0, 5)}...
                        {Assessment?._id?.slice(-5)}
                      </td>
                    </Tooltip>
                    <td
                      className="p-3 max-w-xs truncate whitespace-nowrap overflow-hidden"
                      title={Assessment?.title?.text}
                    >
                      {Assessment?.title?.text}
                    </td>
                    <td className="p-3">
                      {Assessment?.type}
                    </td>
                    <td className="p-3">
                      {Assessment?.access === "PUBLIC" ? "Công khai" : "Riêng tư"}
                    </td>
                    <td className="p-3">
                      {Assessment?.typeExam}
                    </td>
                    <td className="p-3">
                      {Assessment?.subject}
                    </td>
                    <td className="p-3">
                      {Assessment?.isLeaderboard ? "Có" : "Không"}
                    </td>
                    <td className="p-3">
                      <div className="flex items-center justify-center space-x-2 h-full min-h-[40px]">
                        <button
                          onClick={() => handleEditAssessment(Assessment)}
                          className="text-blue-500 hover:text-blue-700 transition"
                          title="Edit Assessment"
                        >
                          <Edit2 className="w-5 h-5" />
                        </button>
                        <button
                          onClick={() => handleDeleteClick(Assessment)}
                          className="text-red-500 hover:text-red-700 transition"
                          title="Delete Assessment"
                        >
                          <Trash2 className="w-5 h-5" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex justify-between p-4 items-center">
          <span>
            Page {isSearch ? "1 / 1" : `${currentPage} / ${totalPages}`}
          </span>
          <div className="flex gap-2">
            <button
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1 || isSearch}
              className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
            >
              Previous
            </button>
            <button
              onClick={() =>
                setCurrentPage((p) => (p < totalPages ? p + 1 : p))
              }
              disabled={currentPage === totalPages || isSearch}
              className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
